import moment from 'moment-timezone'

const getGreetingByHour = (hour) => {
  if (hour >= 5 && hour <= 11) return 'Good morning'
  if (hour >= 12 && hour <= 17) return 'Good afternoon'
  return 'Good evening'
}

export const getLoadingFirstName = () => {
  try {
    const rawLoggedUser = global.localStorage.getItem('loggedUser')
    const parsedLoggedUser = rawLoggedUser ? JSON.parse(rawLoggedUser) : null
    if (parsedLoggedUser?.firstName) return parsedLoggedUser.firstName
  } catch (e) {}
  return null
}

export const getLoadingGreeting = ({ timezone, firstName }) => {
  const safeTimezone = timezone || moment.tz.guess(true)
  const hour = moment().tz(safeTimezone).hour()
  const salutation = getGreetingByHour(hour)

  return firstName ? `${salutation}, ${firstName}` : salutation
}
